"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[517],{

/***/ 8842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1097);
/* harmony import */ var data_locales_id_business_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8593);
/* harmony import */ var lib_gtag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5789);
/* harmony import */ var modules_Home_popupStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5803);






const ButtonScheduleDemo = ({ className ="" , id , variant , wrapperClass =""  })=>{
    const headingTranslationButton = data_locales_id_business_json__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx;
    const { showPopupFormSales  } = (0,modules_Home_popupStore__WEBPACK_IMPORTED_MODULE_5__/* .usePopupStoreFormSales */ .p)((state)=>({
            showPopupFormSales: state.showPopupFormSales
        }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `relative ${wrapperClass ?? ""}`,
        id: id,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: `flex justify-center items-center gap-8 !rounded-8 !text-b1 ${className}`,
            onClick: ()=>{
                (0,lib_gtag__WEBPACK_IMPORTED_MODULE_4__/* .pushDataLayer */ .zz)({
                    event: id
                });
                showPopupFormSales("");
            },
            variant: variant ?? "primary",
            isFull: variant ? true : false,
            children: headingTranslationButton.contactSales
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonScheduleDemo);


/***/ }),

/***/ 8403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ CardCourse; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
;// CONCATENATED MODULE: ./src/lib/date.ts
const toDDMMYYYY = (str, format)=>{
    try {
        str = str.endsWith("Z") ? str : str + "Z";
        const date = new Date(str);
        return date.toLocaleDateString("id", {
            year: "numeric",
            month: format ? format : "long",
            day: "numeric"
        });
    } catch (err) {
        return "";
    }
};
const toDDMMYYYYHHMM = (str, format, useComma, useWeekdays)=>{
    try {
        let comma = useComma == false ? useComma : true;
        str = str.endsWith("Z") ? str : str + "Z";
        const date = new Date(str);
        let objectDate = {
            year: "numeric",
            month: format ? format : "short",
            day: "numeric"
        };
        if (useWeekdays) {
            //@ts-ignore
            objectDate.weekday = "long";
        }
        return(//@ts-ignore
        date.toLocaleDateString("id", objectDate) + (comma ? ", " : " ") + date.toLocaleTimeString("id", {
            hour: "2-digit",
            minute: "2-digit"
        }));
    } catch (err) {
        return "";
    }
};
const toDuration = (minute, isShort = true)=>{
    const minuteString = isShort ? "m" : " menit";
    const hourString = isShort ? "j" : " jam";
    let y = minute % 3600;
    let hours = Math.floor(minute / 60);
    let minutes = y / 60;
    let seconds = y % 60;
    if (minute < 60) {
        return minute + minuteString;
    }
    if (!isShort) {
        return `${hours !== 0 ? `${hours} jam ${Math.floor(minutes)} menit` : `${minute} menit`} ${Math.floor(seconds)} detik`;
    } else {
        return Math.floor(minute / 60) + hourString + minute ? " " + minute + minuteString : "";
    }
};
const toTime = (second)=>{
    const secondInt = ~~second;
    const pad = (n)=>n < 10 ? `0${n}` : `${n}`;
    if (secondInt >= 3600) {
        return `${~~(secondInt / 3600)}:${pad(~~(~~(secondInt % 3600) / 60))}:${pad(secondInt % 60)}`;
    } else if (secondInt >= 60) {
        return `${~~(secondInt / 60)}:${pad(secondInt % 60)}`;
    } else {
        return `0:${pad(secondInt)}`;
    }
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Icon/IconStar.tsx
var IconStar = __webpack_require__(8939);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(1097);
// EXTERNAL MODULE: ./src/lib/helper.ts
var helper = __webpack_require__(9601);
// EXTERNAL MODULE: ./src/lib/device.ts
var device = __webpack_require__(9799);
// EXTERNAL MODULE: ./src/components/Chip/LogoChip.tsx
var LogoChip = __webpack_require__(768);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(3906);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./src/lib/amplitude.ts + 1 modules
var amplitude = __webpack_require__(1272);
// EXTERNAL MODULE: ./src/components/Chip/Chip.tsx
var Chip = __webpack_require__(5867);
// EXTERNAL MODULE: ./src/lib/host.ts
var host = __webpack_require__(5304);
// EXTERNAL MODULE: ./src/components/Icon/IconPlusCircle.tsx
var IconPlusCircle = __webpack_require__(8445);
// EXTERNAL MODULE: ./src/components/Icon/IconCheckCircle.tsx
var IconCheckCircle = __webpack_require__(4110);
// EXTERNAL MODULE: ./src/modules/Business/Selection/cartStore.ts
var cartStore = __webpack_require__(3084);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(6880);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(6562);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Icon/IconPlayCircle.tsx
var IconPlayCircle = __webpack_require__(4016);
;// CONCATENATED MODULE: ./src/components/Card/CardCourse.legacy.tsx




















//@ts-ignore
const CardCourse = ({ isLayoutNew =false , className ="" , isUncheck =false , isHide =false , ...props })=>{
    const isSubdomainTenant = (0,host/* useIsSubdomain */.Do)();
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    const [timeout, setModalTimeout] = (0,react.useState)(null);
    const [checkedCard, setCheckedCard] = (0,react.useState)([]);
    const isTenatURL = (0,host/* useIsTenant */.we)();
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const isBusiness = !isB2B;
    const updateCart = (0,cartStore/* useCartStore */.x)((state)=>state.updateCart);
    let institutionImage = //@ts-ignore
    props?.institution?.image_url ? props?.institution?.image_url : typeof props?.institution == "string" && //@ts-ignore
    props?.institution?.split("||").length > 1 && //@ts-ignore
    props?.institution?.split("||")[1].includes("https") ? props?.institution?.split("||")[1] : props?.institution && typeof props?.institution == "object" ? props?.institution?.image_url : null;
    let institutionName = //@ts-ignore
    props.institution?.name || props.institution?.split("||")[0] || "";
    const classHeight = className == "card-my-class" ? "112px" : className == "card-default" ? "164px" : "171px";
    const wCustom = props?.isHorizontal ? 287 : 328;
    const hCustom = props?.isHorizontal ? 164 : 228;
    const hasUserPaid = props.is_paid;
    const isCourseFree = props.original_price === 0 || props.discounted_price === 0;
    const isCourseFinished = props.enrollment_progress?.finished === props.enrollment_progress?.total;
    const router = (0,next_router.useRouter)();
    const events = {
        event: "course_hover_a",
        property: {
            course_name: props?.name ?? "",
            course_slug: props?.slug ?? "",
            section_name: props?.sectionName ?? "",
            institution_name: //@ts-ignore
            props?.institution_name ?? props.institution?.name ?? "",
            index: props?.index ?? 0,
            page: router.pathname
        }
    };
    const { t  } = (0,useTranslation/* default */.Z)("common");
    if (isLayoutNew) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `w-full overflow-hidden cursor-pointer ${className == "card-my-class" ? "rounded-4" : className == "card-hidden" ? "!opacity-0" : "rounded-8"}`,
            onClick: ()=>{
                //@ts-ignore
                if (props.onSelect) {
                    //@ts-ignore
                    // props.onSelect();
                    updateCart(props);
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "group relative w-full h-full flex flex-col flex-wrap",
                onMouseEnter: isBusiness ? undefined : ()=>{
                    timeout && clearTimeout(timeout);
                    setModalTimeout(setTimeout(()=>{
                        (0,amplitude/* trackEventGTM */.hk)({
                            ...events
                        });
                        (0,amplitude/* trackEventGA */.w7)({
                            ...events
                        });
                    }, 3000));
                },
                onMouseLeave: isBusiness ? undefined : ()=>{
                    timeout && clearTimeout(timeout);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative group-hover:h-fit",
                        children: [
                            props.isHorizontal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: props.image_cover_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: props.name,
                                    src: props.image_cover_url,
                                    width: wCustom,
                                    height: hCustom,
                                    "data-testid": "card-featured_cover",
                                    className: "object-cover w-full h-full object-center",
                                    style: {
                                        borderRadius: className == "card-my-class" ? "4px 4px 0 0" : "8px 8px 0 0"
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-neutral-20" + (props?.isHorizontal ? `${className == "card-my-class" ? " h-[112px]" : ` ${isUncheck ? "h-[156px]" : "h-[164px] xl-max:h-[100px]"}`} w-full` : " h-[228px] w-full"),
                                    style: {
                                        borderRadius: className == "card-my-class" ? "4px 4px 0 0" : "8px 8px 0 0"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: props.image_cover_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: props.name,
                                    src: props.image_cover_url,
                                    className: "object-cover w-full object-center" + ` h-[${isDesktop ? "171" : classHeight}px]`,
                                    style: {
                                        borderRadius: className == "card-my-class" ? "4px 4px 0 0" : "8px 8px 0 0"
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-neutral-20 w-full h-[171px] xl-max:h-[144px]",
                                    style: {
                                        borderRadius: className == "card-my-class" ? "4px 4px 0 0" : "8px 8px 0 0"
                                    }
                                })
                            }),
                            !isBusiness && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 w-full h-full group-hover:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-full flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlayCircle/* IconPlayCircle */.U, {
                                        size: 45,
                                        classes: "m-auto",
                                        isBgCustomized: true
                                    })
                                })
                            }),
                            isBusiness && router.pathname == "/pilih-kursus" && !isUncheck && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 w-full h-full flex justify-end items-start p-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlusCircle/* IconPlusCircle */.O, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-[116px] bg-purple-70",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `w-full h-full group-hover:absolute group-hover:bottom-0 group-hover:flex group-hover:flex-col group-hover:justify-between`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-[-webkit-fill-available] hidden justify-center items-center group-hover:flex",
                                    children: !isBusiness && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/images/icon-play-grey.svg",
                                        alt: "playGrey",
                                        width: 45,
                                        height: 45
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: `gap-8 bg-purple-70 h-full text-white py-14 px-16 items-center transition-height duration-500 ease-in-out absolute`,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-between h-full " + (className == "card-institutions" ? "gap-4" : "gap-8"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-b1 font-medium max-w-full line-clamp-2 text-white text-left",
                                                    children: props.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex gap-8 items-center",
                                                    children: [
                                                        institutionImage && // <LogoChip image_url={institutionImage} size={36} />
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoChip/* LogoChip */.E, {
                                                            image_url: institutionImage,
                                                            size: 40,
                                                            padding: 4,
                                                            useResizeImage: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "grid gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "text-c1 font-light max-w-full truncate text-left",
                                                                    children: institutionName
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex gap-8 justify-start items-center text-c1 font-light",
                                                                    children: [
                                                                        typeof props?.review_summary?.star_avg === "number" && //@ts-ignore
                                                                        props?.review_summary?.star_avg !== 0 && !isB2B ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "flex items-center justify-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStar/* IconStar */.G, {
                                                                                            size: 14,
                                                                                            fill: true,
                                                                                            color: "#EFB443"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "ml-2 text-c1",
                                                                                            children: (0,helper/* formatRating */.A6)(//@ts-ignore
                                                                                            props?.review_summary?.star_avg.toFixed(1))
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                "|"
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                                        props.total_learners !== 0 && !isB2B && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: `${(0,helper/* numberWithCommas */.x6)(props.total_learners)} ${t("pelajar").toLowerCase()}`
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hidden group-hover:inline-block mt-2",
                                                    children: isBusiness ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        className: "hidden w-full group-hover:inline-block mt-2",
                                                        // @ts-ignore
                                                        href: `https://www.gokampus.com/course/${props.slug}`,
                                                        passHref: true,
                                                        // target="__blank"
                                                        rel: "noopener noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            variant: "white_transparant",
                                                            className: "w-full",
                                                            children: "Lihat Kursus"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: props.tags.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                    className: "text-c1 font-medium mb-8 text-left",
                                                                    children: t("skills")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-wrap gap-12 items-center",
                                                                    children: [
                                                                        props?.tags?.slice(0, 3).map((tag, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* Chip */.A, {
                                                                                className: "text-violet_main_to_dark_purple_surface",
                                                                                children: tag || tag.toString()
                                                                            }, i + tag)),
                                                                        props?.tags.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "text-white text-c1 font-medium",
                                                                            children: [
                                                                                "+",
                                                                                props.skills.length - 3,
                                                                                " Tag lainnya"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : null
                                                    })
                                                })
                                            ]
                                        }),
                                        className == "card-my-class" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-b2 pt-4",
                                            children: isCourseFinished && (!hasUserPaid || isCourseFree) ? null : isCourseFinished ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "secondary_white",
                                                size: "medium",
                                                isFull: true,
                                                className: "px-0",
                                                children: "Download Sertifikat"
                                            }) : props.enrollment_progress?.finished === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "secondary_white",
                                                size: "medium",
                                                isFull: true,
                                                children: "Mulai Kelas"
                                            }) : props.enrollment_progress?.finished < props.enrollment_progress?.total ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex h-36 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-b2",
                                                        children: [
                                                            props.enrollment_progress.finished,
                                                            " dari",
                                                            " ",
                                                            props.enrollment_progress.total
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-8"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-1 h-8 bg-neutral-70 rounded-full overflow-hidden relative",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "rounded-full h-full bg-white",
                                                            style: {
                                                                width: props.enrollment_progress.finished / props.enrollment_progress.total * 100 + "%"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }) : null
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    props.isChecked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bg-[#0d0d0d80] top-0 rounded-8 w-full h-full p-8 flex justify-end items-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckCircle/* IconCheckCircle */.B, {})
                    }) : null,
                    isHide && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 bg-[#00000099] w-full h-full flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-b1 font-black text-white",
                            children: "Khusus goKampus Business"
                        })
                    })
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full rounded-2 overflow-hidden",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-64 bg-neutral-20 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        width: 160,
                        height: 64,
                        src: props.image_cover_url,
                        alt: props.name,
                        className: "h-64 w-full object-cover object-center"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-[172px] bg-purple-70 p-8 pt-0 text-white flex flex-col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-48 h-48 rounded-2 -mt-24 bg-white p-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 36,
                                    height: 36,
                                    src: props.institution?.image_url,
                                    alt: props.institution?.name,
                                    className: "object-contain object-center"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-c1 font-light line-clamp-1",
                                children: props.institution?.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-b2 font-bold line-clamp-2",
                                children: props.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-c1 font-light line-clamp-1",
                                children: [
                                    props.total_learners && !isB2B ? `${(0,helper/* numberWithCommas */.x6)(props.total_learners)} pelajar | ` : null,
                                    props.duration == 0 ? null : toDuration(props.duration, false)
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
};


/***/ }),

/***/ 7313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CardNotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1097);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1272);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6562);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);






const CardNotFound = ({ useSmallIcon =false , useMaxWidth =0 , ...props })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const { title , message , useButton , src , className =""  } = props;
    const pushToTrackEvents = (label)=>{
        switch(label){
            case "Mulai Belajar Gratis":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "myclass_startlearning_a"
                });
                break;
            case "Kembali ke Homepage":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_404_back_to_homepage_a"
                });
                break;
            case "Coba Lagi":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_500_retry_a"
                });
                router.reload();
                break;
            case "Kembali":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_500_back_a"
                });
                router.back();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `w-full flex ${useSmallIcon ? "flex-row justify-left" : "flex-col justify-center"} text-center gap-24 items-center m-auto ${className} ${useMaxWidth ? "bg-light_neutral10_to_dark_neutral50 min-h-[320px] rounded-8" : ""}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src ? src : "/images/icon-not-found.png",
                alt: "",
                width: useSmallIcon ? 80 : 120,
                height: useSmallIcon ? 80 : 120
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `flex flex-col gap-24 ${useMaxWidth ? `max-w-[${useMaxWidth}px] px-16 md:px-0` : ""}`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${useSmallIcon ? "grid align-center gap-4" : "flex flex-col gap-8"}`,
                        children: [
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b1 font-bold ${useSmallIcon ? "text-left" : ""}`,
                                children: title
                            }),
                            message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b2 font-medium text-neutral-60 ${useSmallIcon ? "text-left" : ""}`,
                                children: message
                            })
                        ]
                    }),
                    useButton && useButton.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center " + (useButton.length > 1 ? "gap-8" : ""),
                        children: useButton.map((el)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: el.href,
                                onClick: ()=>{
                                    pushToTrackEvents(el.label);
                                    if (el.onClose) {
                                        el.onClose();
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    size: "medium",
                                    isFull: true,
                                    //@ts-ignore
                                    variant: el.variant ? el.variant : "primary",
                                    children: el.label
                                })
                            }, "useButton" + el.href))
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 5867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);

const Chip = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `h-24 flex items-center px-10 text-b2 bg-light_neutral10_to_dark_neutral50 rounded-full ${props.className ? props.className : ""}`,
        children: props.children
    });
};


/***/ }),

/***/ 768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ LogoChip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


const LogoChip = ({ image_url , size =60 , padding =4 , useResizeImage =false , ...props })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `bg-logo_chip rounded-lg p-[${padding}px] w-${size} h-${size} flex justify-center items-center aspect-square ${props?.styles ?? ""}`,
        children: image_url ? useResizeImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: image_url,
            alt: image_url,
            width: size - padding,
            height: size - padding,
            className: `object-contain object-center rounded-lg`
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: image_url,
            className: "w-full h-full object-cover rounded-lg"
        }) : null
    });
};


/***/ }),

/***/ 1396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var components_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1774);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6937);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9799);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1776);






const FooterBusiness = ({})=>{
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_3__/* .useIsDesktop */ .Ce)();
    const [theme] = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_2__/* .useSystemStore */ .m)((state)=>[
            state.theme
        ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Container__WEBPACK_IMPORTED_MODULE_1__/* .ContainerDesktop */ .h, {
            className: "flex",
            useAuto: true,
            children: !isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col justify-between items-center w-full gap-12 pb-[24px] text-violet-100",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                        src: "/logo-1024.png",
                        alt: "learnext_logo",
                        width: 135,
                        height: 36,
                        className: theme === "dark" ? "invert brightness-0" : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-light",
                        children: "AI-Powered Learning for Professionals"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "font-light text-b1",
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " PT. Sistem Sarjana Sejahtera."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row justify-between items-center w-full gap-12 text-violet-100 py-[24px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-light",
                        children: "AI-Powered Learning for Professionals"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                        src: "/logo-1024.png",
                        alt: "learnext_logo",
                        width: 135,
                        height: 36,
                        className: theme === "dark" ? "invert brightness-0" : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "font-light text-b1",
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " PT. Sistem Sarjana Sejahtera."
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FooterBusiness);


/***/ }),

/***/ 4016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ IconPlayCircle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6937);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1776);



const IconPlayCircle = ({ size =24 , color ="#817E8C" , classes ="" , isBgCustomized =false , className ="fill-neutral-80"  })=>{
    const theme = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__/* .useSystemStore */ .m)((state)=>state.theme);
    if (isBgCustomized) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "fill-black_to_black/40",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "0.667969",
                    y: "0.666016",
                    width: "26.6667",
                    height: "26.6667",
                    rx: "13.3333",
                    // fill={color}
                    fillOpacity: "1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M18.5425 11.917L11.8341 8.06974C11.4711 7.86013 11.0591 7.75032 10.64 7.75147C10.2208 7.75263 9.8094 7.86469 9.44756 8.0763C9.08572 8.2879 8.78632 8.5915 8.57979 8.95625C8.37326 9.32101 8.26694 9.73393 8.27163 10.1531V17.8753C8.27163 18.5052 8.52186 19.1093 8.96725 19.5547C9.41265 20.0001 10.0167 20.2503 10.6466 20.2503C11.0636 20.2496 11.4731 20.1394 11.8341 19.9308L18.5425 16.0836C18.9029 15.875 19.2022 15.5753 19.4102 15.2145C19.6183 14.8537 19.7278 14.4445 19.7278 14.0281C19.7278 13.6116 19.6183 13.2024 19.4102 12.8417C19.2022 12.4809 18.9029 12.1811 18.5425 11.9725V11.917Z",
                    fill: "white"
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z",
                    fill: theme == "dark" ? "#C29FEE" : color
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M10.4903 15.4533L15.4505 12.6632C16.1302 12.2809 16.1302 11.3023 15.4505 10.92L10.4903 8.12988C9.82366 7.75492 9 8.23663 9 9.00146V14.5818C9 15.3466 9.82366 15.8283 10.4903 15.4533Z",
                    fill: theme == "dark" ? "#C29FEE" : color
                })
            ]
        });
    }
};


/***/ }),

/***/ 8445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ IconPlusCircle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);


const IconPlusCircle = ({ size =20 , color ="#318A4E"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "49",
        height: "48",
        viewBox: "0 0 49 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                filter: "url(#filter0_dd_2114_5089)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "6.5",
                        y: "2",
                        width: "36",
                        height: "36",
                        rx: "18",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M30.333 19.1667H25.333V14.1667C25.333 13.9456 25.2452 13.7337 25.0889 13.5774C24.9326 13.4211 24.7207 13.3333 24.4997 13.3333C24.2787 13.3333 24.0667 13.4211 23.9104 13.5774C23.7541 13.7337 23.6663 13.9456 23.6663 14.1667V19.1667H18.6663C18.4453 19.1667 18.2334 19.2545 18.0771 19.4107C17.9208 19.567 17.833 19.779 17.833 20C17.833 20.221 17.9208 20.433 18.0771 20.5893C18.2334 20.7455 18.4453 20.8333 18.6663 20.8333H23.6663V25.8333C23.6663 26.0543 23.7541 26.2663 23.9104 26.4226C24.0667 26.5789 24.2787 26.6667 24.4997 26.6667C24.7207 26.6667 24.9326 26.5789 25.0889 26.4226C25.2452 26.2663 25.333 26.0543 25.333 25.8333V20.8333H30.333C30.554 20.8333 30.766 20.7455 30.9223 20.5893C31.0785 20.433 31.1663 20.221 31.1663 20C31.1663 19.779 31.0785 19.567 30.9223 19.4107C30.766 19.2545 30.554 19.1667 30.333 19.1667Z",
                        fill: "#19093A"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                    id: "filter0_dd_2114_5089",
                    x: "0.5",
                    y: "0",
                    width: "48",
                    height: "48",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_2114_5089"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow_2114_5089",
                            result: "effect2_dropShadow_2114_5089"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow_2114_5089",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 8939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ IconStar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);

const IconStar = ({ color ="#551FC1" , size =32 , fill =false , half =false  })=>{
    if (fill) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M29.333 12.8935C29.2488 12.6496 29.0956 12.4354 28.8921 12.2769C28.6886 12.1183 28.4434 12.0222 28.1863 12.0002L20.5996 10.8935L17.1996 4.00019C17.0905 3.77477 16.92 3.58465 16.7078 3.45162C16.4955 3.3186 16.2501 3.24805 15.9996 3.24805C15.7492 3.24805 15.5038 3.3186 15.2915 3.45162C15.0793 3.58465 14.9088 3.77477 14.7996 4.00019L11.3996 10.8802L3.81298 12.0002C3.56621 12.0353 3.33421 12.1388 3.14331 12.2991C2.95241 12.4593 2.81026 12.6699 2.73298 12.9069C2.66224 13.1384 2.65589 13.3849 2.71461 13.6198C2.77334 13.8547 2.89492 14.0692 3.06631 14.2402L8.57298 19.5735L7.23964 27.1469C7.19204 27.3968 7.21697 27.6552 7.31147 27.8915C7.40598 28.1277 7.56612 28.332 7.77298 28.4802C7.9746 28.6243 8.21241 28.7094 8.45971 28.7259C8.70701 28.7424 8.95401 28.6896 9.17298 28.5735L15.9996 25.0135L22.7996 28.5869C22.9868 28.6924 23.1981 28.7476 23.413 28.7469C23.6954 28.7479 23.9709 28.6592 24.1996 28.4935C24.4065 28.3453 24.5666 28.1411 24.6611 27.9048C24.7557 27.6685 24.7806 27.4102 24.733 27.1602L23.3996 19.5869L28.9063 14.2535C29.0988 14.0904 29.2411 13.8761 29.3166 13.6353C29.3922 13.3946 29.3978 13.1374 29.333 12.8935Z",
                fill: color
            })
        });
    } else if (half) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "15",
            height: "14",
            viewBox: "0 0 15 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.3329 5.6408C13.296 5.5341 13.229 5.44038 13.14 5.37101C13.0509 5.30163 12.9437 5.25959 12.8312 5.24996L9.51204 4.7658L8.02454 1.74996C7.97677 1.65134 7.90219 1.56816 7.80934 1.50996C7.71649 1.45177 7.60912 1.4209 7.49954 1.4209C7.38996 1.4209 7.28259 1.45177 7.18974 1.50996C7.09689 1.56816 7.02231 1.65134 6.97454 1.74996L5.48704 4.75996L2.16787 5.24996C2.05991 5.26531 1.95841 5.31061 1.87489 5.38072C1.79138 5.45084 1.72918 5.54296 1.69537 5.64663C1.66442 5.74794 1.66165 5.85576 1.68734 5.95853C1.71303 6.0613 1.76622 6.15514 1.84121 6.22996L4.25037 8.5633L3.66704 11.8766C3.64349 11.9865 3.6522 12.1009 3.69211 12.206C3.73203 12.3111 3.80146 12.4024 3.89205 12.4689C3.98264 12.5355 4.09052 12.5745 4.20273 12.5811C4.31494 12.5878 4.42669 12.562 4.52454 12.5066L7.49954 10.9491L10.4745 12.5066C10.5564 12.5528 10.6489 12.5769 10.7429 12.5766C10.8664 12.5771 10.987 12.5383 11.087 12.4658C11.1775 12.401 11.2476 12.3116 11.2889 12.2082C11.3303 12.1049 11.3412 11.9918 11.3204 11.8825L10.737 8.56913L13.1462 6.2358C13.2304 6.16444 13.2927 6.07066 13.3257 5.96533C13.3588 5.86001 13.3612 5.74747 13.3329 5.6408ZM9.71621 7.94496C9.64869 8.01053 9.59804 8.09147 9.56858 8.18086C9.53912 8.27024 9.53173 8.36543 9.54704 8.4583L9.96704 10.9083L7.49954 9.33328V4.08328L8.59621 5.5533C8.63823 5.63895 8.70062 5.71299 8.77791 5.76893C8.85521 5.82486 8.94504 5.86098 9.03954 5.87413L11.4954 6.22996L9.71621 7.94496Z",
                fill: color
            })
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M29.333 12.8935C29.2488 12.6496 29.0956 12.4354 28.8921 12.2769C28.6886 12.1183 28.4434 12.0222 28.1863 12.0002L20.5996 10.8935L17.1996 4.00019C17.0905 3.77477 16.92 3.58465 16.7078 3.45162C16.4955 3.3186 16.2501 3.24805 15.9996 3.24805C15.7492 3.24805 15.5038 3.3186 15.2915 3.45162C15.0793 3.58465 14.9088 3.77477 14.7996 4.00019L11.3996 10.8802L3.81298 12.0002C3.56621 12.0353 3.33421 12.1388 3.14331 12.2991C2.95241 12.4593 2.81026 12.6699 2.73298 12.9069C2.66224 13.1384 2.65589 13.3849 2.71461 13.6198C2.77334 13.8547 2.89492 14.0692 3.06631 14.2402L8.57298 19.5735L7.23964 27.1469C7.19204 27.3968 7.21697 27.6552 7.31147 27.8915C7.40598 28.1277 7.56612 28.332 7.77298 28.4802C7.9746 28.6243 8.21241 28.7094 8.45971 28.7259C8.70701 28.7424 8.95401 28.6896 9.17298 28.5735L15.9996 25.0135L22.7996 28.5869C22.9868 28.6924 23.1981 28.7476 23.413 28.7469C23.6954 28.7479 23.9709 28.6592 24.1996 28.4935C24.4065 28.3453 24.5666 28.1411 24.6611 27.9048C24.7557 27.6685 24.7806 27.4102 24.733 27.1602L23.3996 19.5869L28.9063 14.2535C29.0988 14.0904 29.2411 13.8761 29.3166 13.6353C29.3922 13.3946 29.3978 13.1374 29.333 12.8935ZM21.133 18.2269C20.9766 18.3781 20.8596 18.5653 20.7922 18.7722C20.7248 18.979 20.7091 19.1992 20.7463 19.4135L21.7063 25.0002L16.693 22.3335C16.5001 22.2308 16.2849 22.1771 16.0663 22.1771C15.8478 22.1771 15.6326 22.2308 15.4396 22.3335L10.4263 25.0002L11.3863 19.4135C11.4236 19.1992 11.4078 18.979 11.3404 18.7722C11.273 18.5653 11.156 18.3781 10.9996 18.2269L6.99964 14.2269L12.613 13.4135C12.829 13.3835 13.0343 13.3009 13.211 13.1731C13.3876 13.0452 13.5303 12.876 13.6263 12.6802L15.9996 7.60019L18.5063 12.6935C18.6024 12.8893 18.745 13.0585 18.9216 13.1864C19.0983 13.3142 19.3036 13.3968 19.5196 13.4269L25.133 14.2402L21.133 18.2269Z",
                fill: color
            })
        });
    }
};


/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var _Icon_IconClose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4132);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9799);
/* harmony import */ var lib_host__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5304);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2977);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6937);







const useOutsideClick = (callback)=>{
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef();
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
        const handleClick = (event)=>{
            if (ref.current && !ref.current?.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return ()=>{
            document.removeEventListener("click", handleClick, true);
        };
    }, [
        ref
    ]);
    return ref;
};
const Modal = ({ useParentRef =null , isAlert =false , isQuiz =false , isShow , isSearch =false , isFullScreen , isTopBorderTransparent , className , childrenClassName , contentClassName , zIndex , contentStyles , contentWidth , isWidthScreen , title , onClose , onClickOutside , children , color ="#19093A" , hFull =true , bottomChildren , customTitleElement , isBundles =false , mainContentHeight  })=>{
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_3__/* .useIsDesktop */ .Ce)();
    const isSubdomainTenant = (0,lib_host__WEBPACK_IMPORTED_MODULE_4__/* .useIsSubdomain */ .Do)();
    const isTenantURL = (0,lib_host__WEBPACK_IMPORTED_MODULE_4__/* .useIsTenant */ .we)();
    const isB2B = isTenantURL;
    const [isClosed, setisClosed] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // const { openModal } = useModalStore((state) => state);
    const isSijuleTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_4__/* .isMoodleURL */ .vO)(window.location.hostname);
    const theme = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_5__/* .useSystemStore */ .m)((state)=>state.theme);
    const screen =  true && window.innerWidth;
    const isMobile = screen < 770;
    const transitionDuration = 700;
    const onCloseModal = ()=>{
        // openModal(false);
        setisClosed(true);
        setTimeout(()=>{
            onClose();
            setisClosed(false);
        }, transitionDuration);
    };
    const ref = useOutsideClick(()=>{
        if (onClickOutside) {
            setisClosed(true);
            setTimeout(()=>{
                onClickOutside();
                setisClosed(false);
            }, transitionDuration);
        }
    });
    // if (isSearch) {
    //   openModal(isSearch);
    // }
    const [heightContent, setHeightContent] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (mainContentHeight) {
            setHeightContent(mainContentHeight);
        }
    }, [
        mainContentHeight,
        isMobile
    ]);
    // console.log("mainContentHeight", mainContentHeight);
    // console.log("heightContent", heightContent);
    if (isShow) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
            initial: {
                opacity: 0
            },
            animate: isClosed ? {
                opacity: 0
            } : {
                opacity: 1
            },
            style: {
                zIndex: zIndex || 9999,
                position: "relative"
            },
            transition: {
                duration: transitionDuration / 1000
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: `fixed inset-0 flex ${!isFullScreen && isSijuleTenant ? "sg-max:items-start" : "sg-max:items-end"} ${isB2B ? "items-start" : "items-center"} justify-center ${!isBundles ? "bg-neutral80_to_dark00" : `${isMobile ? "pointer-events-none" : "bg-neutral80_to_dark00"}`} ${className || ""}`,
                    style: {
                        zIndex: zIndex || 9999
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: ref,
                        className: `relative ${isAlert && !isMobile ? "w-[50%]" : "w-full"} bg-slated_grey2 md:max-w-[740px] max-w-screen overflow-auto
              ${!isBundles ? "px-16 py-16 md:rounded-12 rounded-t-12" : `${isMobile ? `pointer-events-auto h-[calc(100vh-${heightContent}px)]` : "md:rounded-12 rounded-t-12"}`}
              ${contentClassName || ""}`,
                        style: {
                            maxHeight: !isFullScreen && isSijuleTenant ? "74%" : isFullScreen && isSijuleTenant ? "85%" : isFullScreen && !isSijuleTenant ? "95%" : "90%",
                            maxWidth: isWidthScreen || contentWidth,
                            marginTop: isQuiz && !isFullScreen && isSijuleTenant ? "110px" : isQuiz && isFullScreen && isSijuleTenant ? "40px" : "0px",
                            ...contentStyles
                        },
                        children: [
                            customTitleElement ?? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: `flex items-center ${isMobile && isBundles ? "z-10 sticky top-0 bg-white" : ""} ${isFullScreen ? " border-b border-neutral20_to_dark30 px-16 py-16" : ""} ${isTopBorderTransparent ? " !border-transparent" : ""}`,
                                children: [
                                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-b1 text-neutral-80 font-bold",
                                        children: title
                                    }),
                                    onClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        className: "ml-auto",
                                        onClick: onCloseModal,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon_IconClose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            size: 20,
                                            color: theme == "dark" ? "#CCCCCC" : "#3E3851"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: childrenClassName,
                                children: children
                            }),
                            bottomChildren && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `flex items-center${isFullScreen ? " border-b border-neutral20_to_dark30" : ""}`,
                                children: bottomChildren
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    children: `
          html, body {
            overflow: hidden;
          }
        `
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 3837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageHeader_PageHeaderBusiness; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(1097);
// EXTERNAL MODULE: ./src/components/Button/ButtonScheduleDemo.tsx
var ButtonScheduleDemo = __webpack_require__(8842);
// EXTERNAL MODULE: ./src/components/Card/CardNotFound.tsx
var CardNotFound = __webpack_require__(7313);
// EXTERNAL MODULE: ./src/components/Chip/Chip.tsx
var Chip = __webpack_require__(5867);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(1774);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./src/components/Icon/IconClose.tsx
var IconClose = __webpack_require__(4132);
// EXTERNAL MODULE: ./src/lib/device.ts
var device = __webpack_require__(9799);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 218 modules
var motion = __webpack_require__(2977);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/PageHeader/systemStore.ts
var systemStore = __webpack_require__(6937);
;// CONCATENATED MODULE: ./src/components/Drawer/index.tsx







const useOutsideClick = (callback)=>{
    const ref = react.useRef();
    react.useEffect(()=>{
        const handleClick = (event)=>{
            if (ref.current && !ref.current?.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return ()=>{
            document.removeEventListener("click", handleClick, true);
        };
    }, [
        ref
    ]);
    return ref;
};
const Drawer = ({ isShow , isFullScreen , className , contentClassName , zIndex , contentStyles , contentWidth , title , onClose , onClickOutside , children , childrenClass , position ="right"  })=>{
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    const [theme] = (0,systemStore/* useSystemStore */.m)((state)=>[
            state.theme
        ]);
    const ref = useOutsideClick(()=>{
        if (onClickOutside) {
            onClickOutside();
        }
    });
    const classPosition = {
        right: [
            "w-full top-0 right-0 justify-end",
            "w-[25vw] 2xl-max:w-[35vw] rounded-l-16"
        ],
        bottom: [
            "inset-0 w-[100vw] justify-center",
            "w-[100vw] rounded-t-16"
        ],
        top: [
            "inset-0 w-[100vw] justify-start",
            "w-[100vw] rounded-b-16"
        ]
    };
    if (isShow) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
            initial: {
                opacity: 0
            },
            animate: isShow ? {
                opacity: 1
            } : {
                opacity: 0
            },
            style: {
                zIndex: zIndex || 9999,
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `fixed ${classPosition[position][0]} flex ${position == "top" ? "items-start" : "items-end"} bg-[#00000080] ${className || ""}`,
                    style: {
                        zIndex: zIndex || 9999
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: ref,
                        className: `relative bg-white py-[18px] p-[9px] ${classPosition[position][1]} overflow-auto ${isFullScreen ? `h-screen ` : ""} ${contentClassName || ""}`,
                        style: {
                            ...contentStyles
                        },
                        children: [
                            (title || onClose) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: `flex items-center pb-16 pl-[1px] pt-[7px]`,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: theme == "dark" ? "/logo-white-2048.png" : "/logo-2048.png",
                                        alt: "learnext",
                                        width: 120,
                                        height: 21
                                    }),
                                    onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "ml-auto",
                                        onClick: onClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                                            size: 20,
                                            color: "#000000"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: childrenClass ?? "",
                                children: children
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: `
          html, body {
            overflow: hidden;
          }
        `
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var components_Drawer = (Drawer);

;// CONCATENATED MODULE: ./src/components/Icon/IconList.tsx

const IconList = ({ size =24 , color ="#551FC1"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Heroicons/Outline/menu",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Icon",
                d: "M4 6H20M4 12H20M4 18H20",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 6 modules
var InstantSearch = __webpack_require__(1182);
// EXTERNAL MODULE: ./src/components/Icon/IconSearch.tsx
var IconSearch = __webpack_require__(6317);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/widgets/Index.js
var Index = __webpack_require__(8563);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/widgets/Configure.js + 1 modules
var Configure = __webpack_require__(6249);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/connectors/connectSearchBox.js
var connectSearchBox = __webpack_require__(1645);
// EXTERNAL MODULE: ./node_modules/react-spinners/esm/ClipLoader.js
var ClipLoader = __webpack_require__(9702);
// EXTERNAL MODULE: ./src/lib/amplitude.ts + 1 modules
var amplitude = __webpack_require__(1272);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(3906);
// EXTERNAL MODULE: ./src/lib/const.ts
var lib_const = __webpack_require__(5173);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/node_modules/react-instantsearch-core/dist/es/connectors/connectStateResults.js
var connectStateResults = __webpack_require__(1807);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(6562);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Icon/IconStar.tsx
var IconStar = __webpack_require__(8939);
// EXTERNAL MODULE: ./src/lib/helper.ts
var helper = __webpack_require__(9601);
// EXTERNAL MODULE: ./src/modules/Auth/authStore.ts
var authStore = __webpack_require__(474);
// EXTERNAL MODULE: ./src/components/Icon/IconPlayCircle.tsx
var IconPlayCircle = __webpack_require__(4016);
// EXTERNAL MODULE: ./src/lib/object.ts
var object = __webpack_require__(2582);
// EXTERNAL MODULE: ./src/components/Skeleton/Skeleton.tsx
var Skeleton = __webpack_require__(9978);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(9010);
;// CONCATENATED MODULE: ./src/components/InstantSearchBox/searchStore.ts

const useSearchStore = (0,esm/* default */.ZP)((set)=>({
        // state
        currentRecommend: [],
        totalFilter: 0,
        popularCourse: [],
        searches: [],
        keywords: [],
        indexName: "",
        // actions
        setRecommendData (item) {
            set({
                currentRecommend: item
            });
        },
        setTotalFilter (filter) {
            set({
                totalFilter: filter
            });
        },
        setPopularCourse (item) {
            set({
                popularCourse: item
            });
        },
        setSearches (item) {
            set({
                searches: item
            });
        },
        setKeywords (item) {
            set({
                keywords: item
            });
        },
        setIndexName (item) {
            set({
                indexName: item
            });
        }
    }));

// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/lib/host.ts
var host = __webpack_require__(5304);
// EXTERNAL MODULE: ./src/lib/ssr.ts
var ssr = __webpack_require__(1927);
// EXTERNAL MODULE: ./src/modules/Tenant/homeTenantApi.ts
var homeTenantApi = __webpack_require__(7684);
// EXTERNAL MODULE: ./src/lib/algolia.ts + 1 modules
var algolia = __webpack_require__(9763);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx + 1 modules
var Image = __webpack_require__(2317);
// EXTERNAL MODULE: ./src/modules/Home/homeStore.ts
var homeStore = __webpack_require__(8727);
;// CONCATENATED MODULE: ./src/components/InstantSearchBox/SearchHitsCourse.tsx






















function SearchHitsCourse({ searchState , searchResults , indexName , ...props }) {
    const [recommendCourses, setRecommendCourses] = (0,react.useState)([]);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [allCourses, setAllCourses] = (0,react.useState)(null);
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const loginState = (0,authStore/* useAuthStore */.t)((state)=>state.loginState);
    const { setRecommendData  } = useSearchStore();
    const router = (0,next_router.useRouter)();
    /// Access Courses List
    const getCourses = (0,homeTenantApi/* useGetCoursesByTenantSlug */.HL)();
    const currentUser = (0,authStore/* useAuthStore */.t)((state)=>state.currentUser);
    const { setDataCourseId  } = (0,homeStore/* useHomeStore */.o)();
    // checking if the query length is >= 3
    // (since 3 is the minimum Algolia query length)
    const validQuery = searchState.query?.length >= 3;
    const totalData = searchResults?.nbHits;
    const dataCourses = searchResults?.hits.length > 0 && searchState.query && validQuery ? searchResults.hits : searchResults?.hits.length > 0 && !searchState.query ? searchResults.hits : null;
    let seeAllBtn = null;
    let searchResultsLms = null;
    if (props.showBtn) {
        seeAllBtn = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "secondary",
            size: "medium",
            isFull: true,
            className: "px-16 py-8 mt-12",
            onClick: props.onClickEnter,
            children: "Lihat semua"
        });
        searchResultsLms = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center text-b1 font-light text-neutral-60",
            children: [
                totalData > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: totalData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mx-4",
                    children: "Hasil Pencarian untuk"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-medium text-neutral-80",
                    children: [
                        '"',
                        props.searchValue,
                        '"'
                    ]
                })
            ]
        });
    }
    const { forbiddenCourses  } = (0,homeStore/* useHomeStore */.o)();
    const getCourseRecommend = ()=>{
        const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
        const computeIndexName = ()=>{
            if (currentUser) {
                if (currentUser.referral.includes("gaji-c")) {
                    return currentUser.referral !== "gaji-c0000117" ? (0,algolia/* generateIndexName */.AP)("gaji") : (0,algolia/* generateIndexName */.AP)(currentUser.referral);
                }
                return (0,algolia/* generateIndexName */.AP)(window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : window.location.hostname === "lms.injourney.id" ? "injourney" : currentUser.referral === "bssn" ? "tapinkab" : currentUser.referral);
            }
            return (0,algolia/* generateIndexName */.AP)(window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : window.location.hostname === "lms.injourney.id" ? "injourney" : subDomain === "bssn" ? "tapinkab" : subDomain);
        };
        const indexName = computeIndexName();
        setAllCourses(null);
        setIsLoading(true);
        const referral = isB2B ? currentUser?.referral ?? subDomain : currentUser?.referral;
        if (referral && ![
            "moodle",
            "example"
        ].includes(referral)) {
            fetch(referral ? searchState.query ? `/api/search-algolia?indexName=${indexName}&q=${searchState.query}` : `/api/search-algolia?indexName=${indexName}` : "/api/search").then((res)=>res.json()).then((res)=>{
                const data = (0,object/* ArrayObjectSortBy */.Jy)(res.data?.hits, "created_date", true) ?? [];
                const recommendCourses = data.slice(0, 4);
                const filtered = recommendCourses.filter((a)=>!forbiddenCourses.includes(a.slug));
                setRecommendCourses(filtered);
                const topOneCourseSlug = recommendCourses.slice(0, 1).map((course)=>course.slug);
                setDataCourseId(topOneCourseSlug);
                if (recommendCourses.length) {
                    setRecommendData(filtered);
                }
                setTimeout(()=>{
                    setIsLoading(false);
                }, 500);
            });
        }
    };
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    (0,react.useEffect)(()=>{
        if (!searchState.query) {
            setAllCourses(null);
            setIsLoading(true);
            const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
            const referral = isB2B ? currentUser?.referral ?? subDomain : currentUser?.referral;
            if (referral && ![
                "moodle",
                "example"
            ].includes(referral)) {
                getCourses.doFetch({
                    slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : window.location.hostname === "lms.injourney.id" ? "injourney" : // ? referralCode
                    referral,
                    // @ts-ignore
                    popular: 1
                }, {
                    onSuccess (data) {
                        const filtered = data?.data.filter((a)=>!forbiddenCourses.includes(a.slug));
                        // Get first 3 courses
                        setAllCourses(filtered.slice(0, 3));
                        setIsLoading(false);
                    }
                });
            }
            return;
        }
        if (dataCourses && dataCourses.length > 0) {
            const newData = isB2B ? loginState === "LOGIN" ? dataCourses : dataCourses.filter((a)=>!a.tenant) : dataCourses.filter((a)=>!a.is_institution_business);
            const topOneCourseSlug = newData.slice(0, 1).map((course)=>course.slug);
            setDataCourseId(topOneCourseSlug);
            const filtered = newData.filter((a)=>!forbiddenCourses.includes(a.slug));
            // Anonymous user (tidak ada referral)
            if (!currentUser?.referral) {
                if (newData.length > 0) {
                    setAllCourses(filtered);
                } else {
                    getCourseRecommend();
                }
                return;
            }
            // Logged-in user with referral: filter pakai forbiddenCourses
            if (Array.isArray(forbiddenCourses) && forbiddenCourses.length > 0) {
                const showedCourses = newData.filter((course)=>!forbiddenCourses.includes(course.slug));
                setAllCourses(showedCourses);
            } else {
                if (newData.length > 0) {
                    setAllCourses(filtered);
                } else {
                    getCourseRecommend();
                }
            }
        } else {
            getCourseRecommend();
        }
    }, [
        searchState.query
    ]);
    (0,react.useEffect)(()=>{
        if (searchState.query) {
            (0,amplitude/* trackEvent */.L9)({
                event: "explore_searchbar_suggestion_a",
                property: {
                    page: router.pathname,
                    query: searchState.query
                }
            });
        }
    }, [
        searchResults?.hits
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !allCourses || allCourses.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-24",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-12 hg-max:max-h-[50vh] hg-max:overflow-y-scroll",
                children: [
                    !isLoading && recommendCourses.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                        title: "Kursus Tidak Ditemukan",
                        message: "Coba cari kursus dengan kata kunci lain",
                        className: "!gap-16 bg-slated_grey2 rounded-8",
                        useSmallIcon: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-b1 font-medium text-neutral-80",
                        children: t("recommendationForYou")
                    }),
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-12",
                            children: [
                                1,
                                2,
                                3,
                                4
                            ].map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                            className: "h-80 w-140 rounded-8"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col justify-center items-center w-[calc(100%-148px)] gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-16 w-full"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-16 w-full"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                                    className: "h-16 w-full"
                                                })
                                            ]
                                        })
                                    ]
                                }, el + Math.random()))
                        })
                    }) : recommendCourses && recommendCourses.map((hit, index)=>// @ts-ignore
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCourse, {
                            ...hit,
                            index,
                            closeModal: props.closeModal,
                            query: searchState.query ?? ""
                        }, Math.random() + "--" + hit.id))
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                searchResultsLms,
                !searchState.query && allCourses.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-medium text-neutral-80 text-b1 mt-16 md:mt-0",
                    children: t("popularCourses")
                }),
                allCourses.map((hit, index)=>// @ts-ignore
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCourse, {
                        ...hit,
                        index,
                        closeModal: props.closeModal,
                        query: searchState.query ?? ""
                    }, Math.random() + "-" + hit.id)),
                seeAllBtn
            ]
        })
    });
}
/* harmony default export */ var InstantSearchBox_SearchHitsCourse = ((0,connectStateResults/* default */.Z)(SearchHitsCourse));
function ItemCourse({ ...props }) {
    const loginState = (0,authStore/* useAuthStore */.t)((state)=>state.loginState);
    const router = (0,next_router.useRouter)();
    const closeModal = ()=>props.closeModal ? props.closeModal() : null;
    const isLMS = router.pathname.includes("/course/[courseSlug]");
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const institutionName = props?.institution?.name ?? props?.institution?.split("||")[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        onClick: ()=>{
            (0,amplitude/* trackEvent */.L9)({
                event: "explore_searchbar_suggestion_course_a",
                property: {
                    page: router.pathname,
                    course_name: props.name,
                    course_slug: props.slug,
                    institution_name: props.institution.split("||")[0] || "",
                    index: props.index,
                    query: props.query
                }
            });
            closeModal();
        },
        href: loginState == "LOGIN" && isLMS ? {
            pathname: "/r/[page]",
            query: {
                page: `/course/${props?.slug}`
            }
        } : loginState == "LOGIN" ? {
            pathname: "/course/[courseSlug]",
            query: {
                courseSlug: props?.slug
            }
        } : {
            pathname: "/login",
            query: {
                url: encodeURIComponent(`/course/${props?.slug}`)
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row w-full gap-8 cursor-pointer",
            children: [
                props?.image_cover_url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "h-80 w-[140px] relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            alt: props?.name,
                            src: props?.image_cover_url,
                            className: "object-cover object-center rounded-8",
                            width: 140,
                            height: 80
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute rounded-8 w-[140px] h-80 top-0 flex justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlayCircle/* IconPlayCircle */.U, {
                                size: 32,
                                classes: "m-auto",
                                isBgCustomized: true
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-140 h-80 rounded-8 bg-neutral-20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid w-[calc(100%-148px)] justify-start gap-4 text-b2 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-light line-clamp-1",
                            children: institutionName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-neutral-80 font-medium line-clamp-1",
                            children: props?.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-8 justify-start items-center text-c1 font-light",
                            children: [
                                typeof props?.review_summary?.star_avg === "number" && props?.review_summary?.star_avg !== 0 && !isB2B ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStar/* IconStar */.G, {
                                                    size: 12,
                                                    fill: true,
                                                    color: "#EFB443"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ml-2 text-c1",
                                                    children: (0,helper/* formatRating */.A6)(//  @ts-ignore
                                                    props?.review_summary?.star_avg.toFixed(1))
                                                })
                                            ]
                                        }),
                                        "|"
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                props?.total_learners !== 0 && !isB2B && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: `${(0,helper/* numberWithCommas */.x6)(props?.total_learners)} pelajar`
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/PageHeader/BackButton.tsx




const BackButton = ({ size =9 , backTo ="" , customClassName ="" , color ="#19093A"  })=>{
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        onClick: backTo,
        className: `cursor-pointer ${customClassName}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/images/back-button.svg",
            alt: "back",
            width: size,
            height: size,
            className: theme === "dark" ? "invert brightness-0" : ""
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(257);
;// CONCATENATED MODULE: ./src/components/ModalPortal/ModalPortal.tsx


const ModalPortal = ({ children  })=>{
    const [mounted, setMounted] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
        };
    }, []);
    if (typeof document === "undefined" || !mounted) return null;
    const modalRoot = document.getElementById("modal");
    return /*#__PURE__*/ react_dom.createPortal(children, modalRoot);
};
/* harmony default export */ var ModalPortal_ModalPortal = (ModalPortal);

;// CONCATENATED MODULE: ./src/components/ModalPortal/Modal.tsx


const Modal = ({ children , closeModal , show =true , isCenter =false , isBottom =false , zIdx =0 , isFull =false , hide =false , top ="0"  })=>{
    if (!show) return null;
    const modal_style = {
        position: "fixed",
        transform: "translate(-50%, -50%)",
        top: "50%",
        left: "50%",
        zIndex: 1001
    };
    const modal_style_bottom = {
        position: "fixed",
        transform: "translateX(-50%)",
        bottom: "0",
        left: "50%",
        zIndex: 1001
    };
    const modal_style_top = {
        position: "fixed",
        transform: "translateX(-50%)",
        top,
        left: "50%",
        zIndex: 1001
    };
    const overlay = {
        zIndex: zIdx
    };
    const style = "w-full";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPortal_ModalPortal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: closeModal,
                    style: overlay,
                    className: `bg-black opacity-40 top-0 bottom-0 right-0 left-0 fixed ${hide ? "hidden" : ""}`
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: isCenter ? modal_style : isBottom ? modal_style_bottom : modal_style_top,
                    className: `${isFull ? style : ""} ${hide ? "hidden" : ""}`,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var ModalPortal_Modal = (Modal);

// EXTERNAL MODULE: ./src/components/Card/CardCourse.legacy.tsx + 1 modules
var CardCourse_legacy = __webpack_require__(8403);
;// CONCATENATED MODULE: ./src/components/InstantSearchBox/SearchResultsLms.tsx












function SearchResultsLms({ searchState , searchResults , ...props }) {
    // checking if the query length is >= 3
    // (since 3 is the minimum Algolia query length)
    const validQuery = searchState.query?.length >= 3;
    const loginState = (0,authStore/* useAuthStore */.t)((state)=>state.loginState);
    const totalData = searchResults?.nbHits;
    const router = (0,next_router.useRouter)();
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [allCourses, setAllCourses] = (0,react.useState)(null);
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const dataCourses = searchResults?.hits.length > 0 && searchState.query && validQuery ? searchResults.hits : searchResults?.hits.length > 0 && !searchState.query ? searchResults.hits : null;
    (0,react.useEffect)(()=>{
        if (dataCourses && dataCourses.length > 0) {
            const newData = isB2B ? dataCourses : dataCourses.filter((a)=>!a.is_institution_business);
            if (newData && newData.length > 0) {
                setAllCourses(newData);
            } else {
                setAllCourses(null);
            }
        } else {
            setAllCourses(null);
        }
    }, [
        dataCourses
    ]);
    const searchResultsTitle = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center py-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: props.closeModal,
                className: "text-neutral-80 mr-16 cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                    size: 20
                })
            }),
            props.searchValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center text-b1 font-medium text-neutral-60",
                children: [
                    allCourses && allCourses.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: allCourses.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mx-4",
                        children: "Hasil Pencarian untuk"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-neutral-80",
                        children: [
                            '"',
                            props.searchValue,
                            '"'
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute top-[71px] w-full bg-white rounded-b-16",
        children: !allCourses ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* ContainerDesktop */.h, {
            children: [
                searchResultsTitle,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                    title: "Kursus Tidak Ditemukan",
                    message: "Coba cari kursus dengan kata kunci lain",
                    className: "!gap-16 pb-24"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* ContainerDesktop */.h, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        searchResultsTitle,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            onClick: ()=>{
                                (0,amplitude/* trackEvent */.L9)({
                                    event: "explore_searchbar_srp_course_more_a",
                                    property: {
                                        page: router.pathname,
                                        query: props.searchValue
                                    }
                                });
                                props.onClickEnter();
                            },
                            className: "pr-16 text-violet_main_to_dark_purple_surface text-b1 font-medium cursor-pointer",
                            children: "Lihat Semua Hasil"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-4 gap-8 pb-24",
                    children: allCourses.map((hit, index)=>// @ts-ignore
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: loginState == "LOGIN" ? {
                                pathname: "/r/[page]",
                                query: {
                                    page: `/course/${hit?.slug}`
                                }
                            } : {
                                pathname: "/login",
                                query: {
                                    url: encodeURIComponent(`/course/${hit?.slug}`)
                                }
                            },
                            onClick: ()=>{
                                (0,amplitude/* trackEvent */.L9)({
                                    event: "explore_searchbar_srp_course_a",
                                    property: {
                                        page: router.pathname,
                                        query: props.searchValue,
                                        course_name: hit.name,
                                        course_slug: hit.slug,
                                        institution_name: hit?.institution?.split("||")[0],
                                        index
                                    }
                                });
                                props.closeModal();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCourse_legacy/* CardCourse */._, {
                                ...hit,
                                index,
                                isLayoutNew: true,
                                isHorizontal: true,
                                className: "card-default"
                            }, hit.id)
                        }))
                })
            ]
        })
    });
}
/* harmony default export */ var InstantSearchBox_SearchResultsLms = ((0,connectStateResults/* default */.Z)(SearchResultsLms));

;// CONCATENATED MODULE: ./src/components/InstantSearchBox/SearchBox.tsx

















const SearchBox_useOutsideClick = (callback)=>{
    const ref = react.useRef();
    react.useEffect(()=>{
        const handleClick = (event)=>{
            if (ref.current && !ref.current?.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return ()=>{
            document.removeEventListener("click", handleClick, true);
        };
    }, [
        ref
    ]);
    return ref;
};
function SearchBox({ currentRefinement , refine , className , indexName , ...props }) {
    const router = (0,next_router.useRouter)();
    const query = router && router.query.q || null;
    const [theme] = (0,systemStore/* useSystemStore */.m)((state)=>[
            state.theme
        ]);
    /// read value from path param of q
    const [value, setValue] = (0,react.useState)(currentRefinement || query);
    const [timeout, setTime] = (0,react.useState)(null);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const isDesktop =  true && window.innerWidth > 720;
    const [show, setShow] = (0,react.useState)(false);
    const [showLms, setLms] = (0,react.useState)(false);
    const [showBtn, setShowBtn] = (0,react.useState)(false);
    const isLMS = router.pathname.includes("/course/[courseSlug]");
    const isB2B = (0,host/* useIsTenant */.we)() || (0,host/* useIsSubdomain */.Do)();
    const tagsKey = router.query.tagsKey ?? "";
    const institutionKey = router.query.institutionKey ?? "";
    const q = router?.query?.q ?? "";
    const institutionNames = typeof router.query.institutionKey == "string" && router.query.institutionKey ? router.query.institutionKey.split(",") : [];
    const institutionKeyFilter = institutionNames.length ? `${institutionNames.map((ins)=>`institution:"${ins}"`).join(" OR ")}` : "";
    const tagsNames = typeof router.query.tagsKey == "string" && router.query.tagsKey ? router.query.tagsKey.split(",") : [];
    const tagsKeyFilter = tagsNames.length ? `${tagsNames.map((ins)=>`tags:"${ins}"`).join(" OR ")}` : "";
    const isEnteredSearch = tagsKeyFilter !== "" || institutionKeyFilter !== "";
    const isAnyFiltered = q !== "";
    const { dataCourseId  } = (0,homeStore/* useHomeStore */.o)();
    const handleReset = ()=>{
        setValue("");
        router.push({
            pathname: "/"
        });
    };
    const themes = {
        default: "placeholder-input_placeholder bg-white text-neutral-50 ",
        white: "placeholder-white bg-[#ffffff33] text-white ",
        transparent: "placeholder-input_placeholder bg-transparent text-neutral-50 "
    };
    const themeIcon = {
        default: "#5D586C ",
        white: "#FFFFFF ",
        transparent: "#44199A"
    };
    (0,react.useEffect)(()=>{
        if (!q) {
            setValue("");
        }
    }, [
        q
    ]);
    const ref = SearchBox_useOutsideClick(()=>{
        setShow(false);
    });
    const onChangeDebounced = (event)=>{
        const value = event.currentTarget.value;
        // if (value === "") {
        //   setShow(false);
        //   setLms(false);
        //   setShowBtn(false);
        // }
        timeout && clearTimeout(timeout);
        if (value) {
            setIsLoading(true);
        } else {
        // only push route for desktop view
        // No need to change path since this makes
        // LMS page move to homepage when activated (23/7/24)
        // if (isB2B && window.screen.availWidth > 900) {
        //   router.push({
        //     pathname: "/",
        //   });
        // }
        }
        setTime(setTimeout(()=>{
            refine(value);
            setIsLoading(false);
        }, 1000));
        /// No need to redirect since algolia already return
        /// recommendation after delete the form in search box
        // if(isB2B && !value && isDesktop && !isLMS) {
        //   router.push({
        //     pathname: "/",
        //   });
        // }
        setValue(value);
    };
    (0,react.useEffect)(()=>{
        if (props.focus) {
            setShow(true);
        }
    }, [
        props
    ]);
    const toExplorePage = ()=>{
        router.push({
            pathname: "/explore/search",
            query: {
                q: value
            }
        });
        setShow(false);
    };
    const toHomeTenantPage = ()=>{
        router.push({
            pathname: "/",
            query: {
                ...router.query,
                ...value && {
                    q: value
                }
            }
        });
        setShow(false);
    };
    const handleKeyPress = (event)=>{
        if ((event.charCode == 13 || event.key == "Enter") && event.target.value !== "") {
            event.preventDefault();
            (0,amplitude/* trackEventGTM */.hk)({
                event: "explore_searchbar_a",
                property: {
                    query: value,
                    search_slug: dataCourseId,
                    page: router.pathname
                }
            });
            (0,amplitude/* trackEventGA */.w7)({
                event: "explore_searchbar_a",
                property: {
                    query: value,
                    search_slug: dataCourseId,
                    page: router.pathname
                }
            });
            if (isDesktop && isLMS) {
                event.target.blur();
                setShow(false);
                /// Directly redirect user to search page
                /// Instead of showing popup result 4 recommendation courses
                // setLms(true);
                if (isB2B) {
                    toHomeTenantPage();
                } else {
                    toExplorePage();
                }
                return;
            }
            if (isLMS && !isDesktop) {
                event.target.blur();
                /// Directly redirect user to search page
                /// Instead of showing popup result 4 recommendation courses
                // setShowBtn(true);
                if (isB2B) {
                    toHomeTenantPage();
                } else {
                    toExplorePage();
                }
                return;
            }
            if (isB2B) {
                toHomeTenantPage();
            } else {
                toExplorePage();
            }
        }
    };
    const renderResult = ()=>{
        let courseSuggestions = 3;
        if (showBtn) courseSuggestions = 4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `${props.contentClass ?? ""} z-50 md:bg-slated_grey p-16 grid gap-12 rounded-12 shadow-dropdown absolute pointer-events-auto z-200 w-full h-fit top-50 `,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Index/* default */.Z, {
                indexName: indexName ?? lib_const/* CONST.ALGOLIA_SEARCH_INDEX */.o.ALGOLIA_SEARCH_INDEX,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                        hitsPerPage: courseSuggestions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearchBox_SearchHitsCourse, {
                        searchValue: value,
                        showBtn: showBtn,
                        onClickEnter: isB2B ? toHomeTenantPage : toExplorePage,
                        closeModal: props.onBackHeader,
                        indexName: indexName
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex gap-12 items-center",
        ref: ref,
        children: [
            props.onBackHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                backTo: ()=>props.onBackHeader()
            }),
            props.position == "left" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // className={`absolute right-0 flex items-center bg-white_to_dark20 ${
                //   props.onBackHeader ? "left-48 z-20 mr-2" : "left-10 z-10"
                // }`}
                className: `absolute top-10 ${props.onBackHeader ? "left-48 z-20 mr-2" : "left-10 z-10"}`,
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipLoader/* default */.Z, {
                    size: 16,
                    color: "black"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: isAnyFiltered ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleReset,
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                            size: 20,
                            color: "#883CFF"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* IconSearch */.j, {
                        size: 20,
                        color: theme === "dark" ? "#C29FEE" : "#883CFF"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: `${className} ${props.position == "left" ? props.onBackHeader ? "pl-40" : "pl-32" : ""} relative h-40 p-[7px] text-b1 font-light border border-neutral40_to_dark20 rounded-100 ${themes[props.theme ?? "default"]} focus:outline focus:outline-2 focus:outline-purple-50 text-ellipsis`,
                placeholder: props?.placeholder ?? "Search...",
                onChange: (e)=>{
                    onChangeDebounced(e);
                },
                onKeyPress: handleKeyPress,
                onFocus: ()=>{
                    (0,amplitude/* trackEventGTM */.hk)({
                        event: "explore_searchbar_start_a",
                        property: {
                            page: router.pathname
                        }
                    });
                    (0,amplitude/* trackEventGA */.w7)({
                        event: "explore_searchbar_start_a",
                        property: {
                            page: router.pathname
                        }
                    });
                    (0,amplitude/* trackEventGTM */.hk)({
                        event: "explore_searchbar_start_a",
                        property: {
                            page: router.pathname
                        }
                    });
                    (0,amplitude/* trackEventGA */.w7)({
                        event: "explore_searchbar_start_a",
                        property: {
                            page: router.pathname
                        }
                    });
                    setShow(true);
                    setLms(false);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter") {
                        props?.setModal && props.setModal(false);
                        router.push({
                            pathname: "/",
                            query: {
                                q: value
                            }
                        });
                    }
                },
                value: value,
                autoFocus: props.focus ?? false
            }),
            props?.position == "right" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // className={"absolute top-10 right-10"}
                className: "absolute right-0 flex items-center bg-light_neutral10_to_dark_neutral50 border border-neutral40_to_dark20",
                style: {
                    height: "100%",
                    padding: "10px",
                    borderTopRightRadius: "100px",
                    borderBottomRightRadius: "100px"
                },
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipLoader/* default */.Z, {
                    size: 16,
                    color: "fill-neutral-50"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: isAnyFiltered ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: handleReset,
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                            size: 20,
                            color: theme === "dark" ? "#C29FEE" : "#883CFF"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* IconSearch */.j, {
                        size: 20,
                        color: theme === "dark" ? "#C29FEE" : "#883CFF"
                    })
                })
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: renderResult()
            }),
            showLms && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPortal_Modal, {
                isFull: true,
                closeModal: ()=>setLms(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Index/* default */.Z, {
                    indexName: indexName ?? lib_const/* CONST.ALGOLIA_SEARCH_INDEX */.o.ALGOLIA_SEARCH_INDEX,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                            hitsPerPage: 4
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearchBox_SearchResultsLms, {
                            searchValue: value,
                            onClickEnter: isB2B ? toHomeTenantPage : toExplorePage,
                            closeModal: ()=>setLms(false)
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var InstantSearchBox_SearchBox = ((0,connectSearchBox/* default */.Z)(SearchBox));

// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch.umd.js
var algoliasearch_umd = __webpack_require__(4260);
var algoliasearch_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_umd);
;// CONCATENATED MODULE: ./src/components/InstantSearchBox/InstantSearchBox.tsx






const searchClient = algoliasearch_umd_default()(lib_const/* CONST.ALGOLIA_APP_ID */.o.ALGOLIA_APP_ID, lib_const/* CONST.ALGOLIA_SEARCH_KEY */.o.ALGOLIA_SEARCH_KEY);
const InstantSearchBox = ({ indexName , ...props })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearch/* default */.Z, {
            searchClient: searchClient,
            indexName: indexName ?? lib_const/* CONST.ALGOLIA_SEARCH_INDEX */.o.ALGOLIA_SEARCH_INDEX,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-8 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearchBox_SearchBox, {
                    ...props,
                    indexName: indexName,
                    className: props.className ?? ""
                })
            })
        })
    });
};
/* harmony default export */ var InstantSearchBox_InstantSearchBox = (InstantSearchBox);

// EXTERNAL MODULE: ./src/modules/Business/Selection/CartList.tsx + 2 modules
var CartList = __webpack_require__(5592);
// EXTERNAL MODULE: ./src/modules/Business/Selection/cartStore.ts
var cartStore = __webpack_require__(3084);
;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeaderBusiness.tsx















const PageHeaderBusiness = ({ isTransparent , useSearch =false  })=>{
    const router = (0,next_router.useRouter)();
    const [showDrawer, setShowDrawer] = (0,react.useState)(false);
    const [showMenu, setShowMenu] = (0,react.useState)(false);
    const currentCart = (0,cartStore/* useCartStore */.x)((state)=>state.currentCart);
    const [theme] = (0,systemStore/* useSystemStore */.m)((state)=>[
            state.theme
        ]);
    const [menus, setMenus] = (0,react.useState)([
        {
            label: "Benefit",
            href: "",
            anchor: "home-benefit"
        },
        {
            label: "Kursus",
            href: "",
            anchor: "home-access"
        },
        {
            label: "Paket",
            href: "",
            anchor: "home-packets"
        }
    ]);
    const isMobileView =  true && window.screen.width < 993;
    const handleScroll = (id)=>{
        setShowMenu(false);
        const elem = document.getElementById(id);
        if (!elem) return;
        const offset = -100;
        const y = elem.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    };
    const listAllowedHeaderBusiness = [
        "/",
        "/my-class",
        "/course/[courseSlug]",
        "/transactions/[transactionId]"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "w-full z-50 h-72 px-[12px] lg:px-[80px] bg-[#fff] sticky top-0 shadow-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
                className: "h-full flex items-center justify-between",
                useAuto: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center w-full gap-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-32 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: theme == "dark" ? "/logo-white-2048.png" : "/logo-2048.png",
                                        alt: "learnext",
                                        width: 120,
                                        height: 21
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex gap-32 hidden lg:block lg:flex",
                                    children: menus.map((a)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            //@ts-ignore
                                            onClick: ()=>handleScroll(a.anchor),
                                            className: "cursor-pointer font-medium text-black",
                                            children: a.label
                                        }, a.label))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "m-auto mr-0 sg-max:hidden",
                            children: !isTransparent && listAllowedHeaderBusiness.includes(router.pathname) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonScheduleDemo/* default */.Z, {
                                className: "!h-40",
                                id: "cta-header"
                            })
                        }),
                        useSearch || !listAllowedHeaderBusiness.includes(router.pathname) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-end gap-32 items-center",
                            children: [
                                useSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg-max:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearchBox_InstantSearchBox, {
                                        placeholder: "Cari kursus disini",
                                        position: "right",
                                        className: "w-400",
                                        theme: "transparent"
                                    })
                                }),
                                !listAllowedHeaderBusiness.includes(router.pathname) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    className: `rounded-8 !p-8 hover-unset relative !border-0  ${currentCart.length > 0 ? "!bg-light_neutral10_to_dark_neutral50 hover:bg-light_neutral10_to_dark_neutral50" : "!bg-white hover:bg-white"}`,
                                    onClick: ()=>setShowDrawer(!showDrawer),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-violet_main_to_dark_purple_surface font-medium sm-max:text-c1",
                                            children: "Kursus Pilihanmu"
                                        }),
                                        currentCart.length > 0 && router.pathname !== "/cart/[id]" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "min-w-[20px] min-h-20 px-4 text-c2 flex items-center justify-center absolute text-white rounded-18 bg-red-50 right-0 top-0 translate-x-[40%] -translate-y-[30%]",
                                            children: currentCart.length
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden sg-max:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setShowMenu(!showMenu);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconList, {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Drawer, {
                isShow: showDrawer,
                isFullScreen: !isMobileView,
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-16",
                    children: [
                        "Kursus Pilihan",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chip/* Chip */.A, {
                            className: "bg-light_neutral10_to_dark_neutral50 text-violet_main_to_dark_purple_surface",
                            children: [
                                router.pathname === "/cart/[id]" ? 0 : currentCart.length,
                                " Kursus"
                            ]
                        })
                    ]
                }),
                onClose: ()=>setShowDrawer(false),
                childrenClass: "flex flex-col justify-between h-[95%]",
                position: isMobileView ? "bottom" : "right",
                children: [
                    router.pathname === "/cart/[id]" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                        title: "Kamu belum memilih kursus",
                        message: "Jelajahi kursus dan pilih kursus yang paling sesuai untuk perusahaanmu",
                        className: "!gap-16",
                        useButton: [
                            {
                                href: "/pilih-kursus",
                                label: "Pilih Kursus",
                                variant: "primary",
                                onClose: ()=>setShowDrawer(false)
                            }
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartList/* CartList */.A, {
                        className: currentCart.length ? "mb-16 !p-0 grid grid-cols-1 gap-16 max-h-[80vh] overflow-auto" : "h-[80vh]",
                        title: "",
                        onClose: ()=>setShowDrawer(false),
                        onClickButton: ()=>setShowDrawer(false),
                        wrapperList: "py-20 !pr-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "m-auto mb-0 w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "w-full",
                            onClick: ()=>{
                                setShowDrawer(false);
                                //@ts-ignore
                                router.replace("/cart");
                            },
                            state: currentCart.length > 0 && router.pathname !== "/cart/[id]" ? "active" : "disabled",
                            children: "Lanjutkan"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Drawer, {
                isShow: showMenu,
                position: "top",
                onClose: ()=>setShowMenu(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-48 pt-[24px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-32",
                            children: menus.map((a)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: ()=>handleScroll(a.anchor),
                                    className: "cursor-pointer font-medium text-black",
                                    children: a.label
                                }, a.label))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonScheduleDemo/* default */.Z, {
                        className: "!h-40 w-full",
                        id: "cta-header"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageHeader_PageHeaderBusiness = (PageHeaderBusiness);


/***/ }),

/***/ 5592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ CartList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./src/components/Card/CardNotFound.tsx
var CardNotFound = __webpack_require__(7313);
// EXTERNAL MODULE: ./src/modules/Business/Selection/cartStore.ts
var cartStore = __webpack_require__(3084);
// EXTERNAL MODULE: ./src/components/Icon/IconPlayCircle.tsx
var IconPlayCircle = __webpack_require__(4016);
// EXTERNAL MODULE: ./src/components/Icon/IconStar.tsx
var IconStar = __webpack_require__(8939);
// EXTERNAL MODULE: ./src/lib/helper.ts
var helper = __webpack_require__(9601);
;// CONCATENATED MODULE: ./src/components/Icon/IconTrash.tsx

const IconTrash = ({ size =24 , // color = "#19093A",
className ="fill-neutral-80"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19ZM14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18Z"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(3906);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Card/CardCourseHorizontal.tsx








const CardCourseHorizontal = ({ ...props })=>{
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between items-center w-full cursor-pointer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row w-[-webkit-fill-available] gap-8",
                children: [
                    props?.image_cover_url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "h-80 w-[140px] relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: props?.name,
                                src: props?.image_cover_url,
                                className: "object-cover object-center rounded-8",
                                width: 140,
                                height: 80
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute rounded-8 w-[140px] h-80 top-0 flex justify-center items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlayCircle/* IconPlayCircle */.U, {
                                    size: 32,
                                    classes: "m-auto",
                                    isBgCustomized: true
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-140 h-80 rounded-8 bg-neutral-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-fit 2xl-max:max-w-[calc(100%-148px)] justify-center gap-4 text-b2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-light line-clamp-1",
                                children: typeof props?.institution == "string" ? props?.institution.split("||")[0] || "" : props.institution.name || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `text-neutral-80 font-medium line-clamp-1 ${//  @ts-ignore
                                router.pathname === "/cart" ? "w-full" : "max-w-[168px]"}`,
                                children: props?.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-8 justify-start items-center font-light",
                                children: [
                                    typeof props?.review_summary?.star_avg === "number" && // @ts-ignore
                                    props?.review_summary?.star_avg !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStar/* IconStar */.G, {
                                                        size: 12,
                                                        fill: true,
                                                        color: "#EFB443"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-2",
                                                        children: (0,helper/* formatRating */.A6)(//  @ts-ignore
                                                        props?.review_summary?.star_avg.toFixed(1))
                                                    })
                                                ]
                                            }),
                                            "|"
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    props?.total_learners !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: `${(0,helper/* numberWithCommas */.x6)(props?.total_learners)} pelajar`
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            props.onDelete && router.pathname !== "/cart/[id]" && //@ts-ignore
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: props.onDelete,
                className: "m-auto mr-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrash, {
                    color: "#817E8C"
                })
            })
        ]
    });
};
/* harmony default export */ var Card_CardCourseHorizontal = (CardCourseHorizontal);

;// CONCATENATED MODULE: ./src/modules/Business/Selection/CartList.tsx





const CartList = ({ className ="" , title , onClose , onClickButton , beforeInput , data , wrapperList  })=>{
    const { currentCart , updateCart  } = (0,cartStore/* useCartStore */.x)((state)=>({
            currentCart: state.currentCart,
            updateCart: state.updateCart
        }));
    let allData = data ?? currentCart;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `grid gap-16 ${className}`,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-h4 font-bold",
                children: title
            }),
            allData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `bg-white rounded-16 mb-16 grid grid-cols-1 gap-16 h-fit ${wrapperList ?? "p-20"}`,
                children: [
                    beforeInput && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: beforeInput
                    }),
                    allData.map((course, index)=>//@ts-ignore
                        /*#__PURE__*/ (0,react.createElement)(Card_CardCourseHorizontal, {
                            ...course,
                            index,
                            onDelete: ()=>updateCart(course),
                            key: Math.random()
                        }))
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-20 bg-white rounded-16 flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                    title: "Kamu belum memilih kursus",
                    message: "Jelajahi kursus dan pilih kursus yang paling sesuai untuk perusahaanmu",
                    className: "!gap-16",
                    useButton: [
                        {
                            href: "/pilih-kursus",
                            label: "Pilih Kursus",
                            variant: "primary",
                            onClose: ()=>onClickButton()
                        }
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 3084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useCartStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9010);

const useCartStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        currentCart: [],
        updateCart (item) {
            set((state)=>({
                    currentCart: [
                        ...state.currentCart
                    ].find((a)=>a.id === item.id) ? [
                        ...state.currentCart
                    ].filter((x)=>x.id !== item.id) : [
                        ...state.currentCart,
                        {
                            ...item
                        }
                    ]
                }));
        },
        postCart (data) {
            set({
                currentCart: data
            });
        }
    }));


/***/ }),

/***/ 8727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useHomeStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9010);

const useHomeStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // States
        userNotifications: null,
        newLessonComplete: false,
        renderingStep: 1,
        isShowSearchModal: true,
        forbiddenCourses: "[]",
        hideSlugs: "[]",
        isNewHide: false,
        dataCourseId: [],
        isLoading: false,
        // Actions
        setNotification (userNotifications) {
            set({
                userNotifications
            });
        },
        setNewLessonComplete (newLessonComplete) {
            set({
                newLessonComplete
            });
        },
        setRenderingStep: (step)=>set((state)=>({
                    renderingStep: typeof step === "function" ? step(state.renderingStep) : step
                })),
        setIsShowSearchModal: (isShow)=>set((state)=>({
                    isShowSearchModal: typeof isShow === "function" ? isShow(state.isShowSearchModal) : isShow
                })),
        setForbiddenCourses: (courses)=>set({
                forbiddenCourses: courses
            }),
        setHideSlugs: (slugs)=>set({
                hideSlugs: slugs
            }),
        setIsNewHide: (isNewHide)=>set((state)=>({
                    isNewHide: typeof isNewHide === "function" ? isNewHide(state.isNewHide) : isNewHide
                })),
        setDataCourseId: (dataCourseId)=>set((state)=>({
                    dataCourseId: typeof dataCourseId === "function" ? dataCourseId(state.dataCourseId) : dataCourseId
                })),
        setIsLoading: (isLoading)=>set((state)=>({
                    isLoading: typeof isLoading === "function" ? isLoading(state.isLoading) : isLoading
                }))
    }));


/***/ })

}]);